import { usersSlice } from './slice';

export * from './users';
export * from './async';

const Reducer = usersSlice.reducer;
const Actions = usersSlice.actions;

export { Reducer, Actions };
